// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8FbQ6","title":"styles_title__UAthq"};